import { BellRing } from "lucide-react";

export const REMIND_LEADS = [
  ["none", "No reminder"],
  ["1h", "An hour before"],
  ["2h", "2 hours before"],
  ["3h", "3 hours before"],
  ["12h", "12 hours before"],
  ["1d", "The day before"],
  ["2d", "2 days before"],
  ["3d", "3 days before"],
  ["1w", "A week before"],
  ["custom", "A day and time I pick"],
];

const DAY_LEADS = ["1d", "2d", "3d", "1w"];

const cls = "min-h-[36px] rounded-xl border border-white/10 bg-page px-2.5 text-xs text-ink outline-none";

// How far ahead to be nudged, and at what time — one row, no surprises.
export const RemindPicker = ({ value, onChange, accent, testid = "remind" }) => {
  const spec = { lead: "none", time: "09:00", at: "", ...(value || {}) };
  const set = (patch) => onChange({ ...spec, ...patch });

  return (
    <span className="inline-flex flex-wrap items-center gap-1.5" data-testid={`${testid}-picker`}>
      <BellRing className="h-3.5 w-3.5" style={{ color: spec.lead === "none" ? "#9AA3B2" : accent }} />
      <select
        data-testid={`${testid}-lead`}
        value={spec.lead}
        onChange={(e) => set({ lead: e.target.value })}
        className={cls}
      >
        {REMIND_LEADS.map(([key, label]) => (
          <option key={key} value={key}>{label}</option>
        ))}
      </select>
      {DAY_LEADS.includes(spec.lead) && (
        <input
          data-testid={`${testid}-time`}
          type="time"
          value={spec.time}
          onChange={(e) => set({ time: e.target.value })}
          className={cls}
        />
      )}
      {spec.lead === "custom" && (
        <input
          data-testid={`${testid}-at`}
          type="datetime-local"
          value={spec.at}
          onChange={(e) => set({ at: e.target.value })}
          className={cls}
        />
      )}
    </span>
  );
};
